import React from 'react';
import PropTypes from 'prop-types';
import './App.css';
import Spinner from './components/Spinner/Spinner';
import styled from 'styled-components';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import ActionCreators from "./store/actions";
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import MomentUtils from "@date-io/moment";
import moment from "moment-timezone";
import AuthView from "./views/AuthView";
import { createMuiTheme, MuiThemeProvider } from '@material-ui/core/styles';
import Snackbar from './components/Snackbar/RequestSnackbar';
import Routes from './views/Routes';
import { themeTypeToBool } from './utils/helpers';
import CssBaseline from "@material-ui/core/CssBaseline";
import { blueGrey } from "@material-ui/core/colors";
import "./components/Common/scrollbarCss.css";
import CookieInfoBar from './components/Utilities/Cookies/CookieInfoBar';

const StyledApp = styled.div`
  height: 100vh;
  scrollbar-color: black;
  position: relative;
  `;

const theme = themeType => ({
    overrides: {
        MuiButton: {
            containedPrimary: {
                color: "#FFF"
            }
        },
        MuiInputLabel: {
            root: {
                color: themeTypeToBool(themeType) ? "#000" : "#FAFAFA"
            }
        },
        MuiSelect: {
            select: {
                background: "transparent",
                "&:focus": {
                    background: "none",
                    backgroundColor: "none",
                }
            },
        },
        MuiInputBase: {
            input: {
                "&:-internal-autofill-selected": {
                    WebkitBoxShadow: `0 0 0 1000px ${themeTypeToBool(themeType) ? "#FFFFFF" : "#34344A"} inset`,
                    WebkitTextFillColor: themeTypeToBool(themeType) ? "#000" : "#FFF",
                },
                "&:-webkit-autofill": {
                    WebkitBoxShadow: `0 0 0 1000px ${themeTypeToBool(themeType) ? "#FFFFFF" : "#34344A"} inset`,
                    WebkitTextFillColor: themeTypeToBool(themeType) ? "#000" : "#FFF",
                }
            },
        }
    },
    palette: {
        type: themeType,
        primary: {
            main: "#A3A0FB"
        },
        secondary: blueGrey,
        text: {
            secondary: "rgba(255, 255, 255, 0.9)"
        },
        background: {
            default: themeTypeToBool(themeType) ? "#FAFAFA" : "rgba(67,66,93, 0.9)",
            paper: themeTypeToBool(themeType) ? "#FFFFFF" : "#34344A"
        }
    },
    typography: {
        fontFamily: [
            "ToyotaDisplay-Regular,Roboto"
        ].join(','),
        h3: {
            fontSize: "2.5rem"
        },
        subtitle2: {
            fontSize: "1rem",
            fontWeight: 500,
            lineHeight: 1.75
        },
        body1: {
            fontWeight: 400,
            fontSize: "0.875rem",
            lineHeight: 1.43,
            letterSpacing: "0.01071em",
        },
        body2: {
            fontSize: "0.75rem"
        }
    },
});

class App extends React.Component {

    render() {
        const { token, isLoaded = true, themeType = "light" } = this.props;
        const muiTheme = createMuiTheme(theme(themeType));

        return (
            <MuiThemeProvider theme={muiTheme}>
                <MuiPickersUtilsProvider utils={MomentUtils} libInstance={moment} locale="pl">
                    <CssBaseline />
                    <StyledApp>
                        <Snackbar type={this.props.snackType} />
                        {!isLoaded && <Spinner />}
                        {!token ? <AuthView /> : <Routes />}
                        <CookieInfoBar />
                    </StyledApp>
                </MuiPickersUtilsProvider>
            </MuiThemeProvider>
        );
    }
}

const mapStateToProps = state => {
    return {
        isLoaded: state.requestReducer.isLoaded,
        token: state.authReducer.token,
        themeType: state.requestReducer.themeType,
        snackType: state.requestReducer.snackType
    };
};

const mapDispatchToProps = dispatch => {
    return bindActionCreators(ActionCreators, dispatch);
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(App);

App.propTypes = {
    //redux
    token: PropTypes.string,
    isLoaded: PropTypes.bool,
    themeType: PropTypes.string,
    snackType: PropTypes.string
};